import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '88px',
    height: '88px',
    maxHeight: '88px',
    borderBottom: '1px solid #C6C6C6',
    background: 'white',

    [theme.breakpoints.down('md')]: {
      boxShadow: '0px 8px 16px 2px rgba(0, 0, 0, 0.08)',
      minHeight: '60px',
      height: '60px',
      maxHeight: '60px'
    }
  },

  sectionContainer: {
    padding: '0 1rem'
  },

  rightSection: {
    flex: 1,
    justifyContent: 'flex-end',
    minWidth: 'unset'
  },

  flex2: {
    flex: 2
  },

  avatarNames: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.base,
    marginLeft: '1rem',
    cursor: 'default',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('md')]: {
      maxWidth: 100
    }
  },

  me: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.base,
    cursor: 'default',
    margin: 12
  },

  addMoreParticipants: {
    marginLeft: '0.5rem'
  },

  addTooltip: {
    margin: '29px 0 0 5px'
  },

  flexAlignCenter: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
  },

  endConversation: {
    cursor: 'pointer',
    margin: 10,

    '& svg': {
      transform: 'rotate(180deg)'
    }
  },

  menuPaper: {
    border: '1px solid #F0F0F0',
    borderRadius: '8px',
    boxShadow: '0px 20px 30px 2px rgba(0, 0, 0, 0.16)',
    minWidth: '320px',
    width: '320px',
    maxWidth: '320px',
    background: 'white',
    color: 'black'
  },

  menuList: {
    padding: '0'
  },

  pointer: {
    cursor: 'pointer'
  },

  myDetails: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  nameSectionContainer: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 16
    }
  },

  favBtn: {
    marginLeft: '0px! important',
    marginRight: '0.35rem'
  }
}))

export default useStyles
